// Pure string→string so the catalog can become locales/fr.json if a library is adopted.
export const fr = {
  'common.close': 'Fermer',
  'common.retry': 'Réessayer',
  'common.loading': 'Chargement…',
  'time.relative.now': "à l'instant",
  'time.relative.minutes': 'il y a {{count}} min',
  'time.relative.hours': 'il y a {{count}} h',
  'time.relative.yesterday': 'hier',
  'time.relative.days': 'il y a {{count}} j',
  'common.logout': 'Se déconnecter',
  'common.later': 'Plus tard',
  'common.save': 'Enregistrer',
  'common.cancel': 'Annuler',
  'home.previous.label': 'Grilles précédentes',
  'home.cell.aria.started': ' — commencée — {{pct}} %',
  'home.greeting.matin.hi': 'Bonjour',
  'home.greeting.matin.sub': 'Une nouvelle grille pour bien commencer la journée.',
  'home.greeting.apresMidi.hi': 'Bel après-midi',
  'home.greeting.apresMidi.sub': 'Une grille pour souffler un peu.',
  'home.greeting.soir.hi': 'Bonsoir',
  'home.greeting.soir.sub': "La grille du soir t’attend.",
  'home.greeting.nuit.hi': 'Encore debout ?',
  'home.greeting.nuit.sub': 'La nuit est calme — parfaite pour quelques mots.',
  'home.greeting.neutral.hi': 'Bonjour',
  'home.greeting.neutral.sub': 'Une nouvelle grille rien que pour toi.',
  'home.join.placeholder': 'Rejoindre avec un code',
  'home.join.aria.field': 'Rejoindre une partie avec un code',
  'home.join.aria.reveal': 'Afficher le code',
  'home.join.aria.hide': 'Masquer le code',
  'home.join.aria.submit': 'Rejoindre la partie',
  'home.join.error.invalidCode': 'Le code fait 6 caractères (lettres et chiffres).',
  'home.daily.aria.loading': 'Chargement de la grille du jour',
  'home.daily.eyebrow.error': 'Chargement impossible',
  'home.daily.eyebrow.title': 'Grille du jour',
  'home.daily.eyebrow.gridNumber': ' · n°{{number}}',
  'home.daily.date.error': 'Grille indisponible',
  'home.play.cta.play': 'Jouer',
  'home.play.cta.unavailable': 'Bientôt disponible',
  'home.coop.cta.creating': 'Création…',
  'home.coop.cta.create': 'Jouer à plusieurs',
  'home.legalNav.aria.label': 'Liens légaux',
  'home.legalNav.privacy': 'Confidentialité',
  'home.legalNav.terms': 'Mentions légales',
  'home.cell.aria.today': " (aujourd’hui)",
  'home.cell.aria.solved': ' — terminée',
  'home.miniGame.aria.loading': 'Chargement du mot du jour',
  'home.miniGame.aria.hideKeyboard': 'Masquer le clavier',
  'home.miniGame.sr.checking': 'Vérification du mot…',
  'home.miniGame.aria.cellSuffix': ' — lettre {{index}} sur {{total}}',
  'home.miniGame.skip': 'Passer ›',
  'home.host.signInPrompt': 'Connecte-toi pour créer une partie',
  'home.host.subtitle': 'Héberger une partie demande un compte. Rejoindre avec un code reste possible sans compte.',
  'v2.signin.connecting': 'Connexion…',
  'v2.signin.google': 'Se connecter avec Google',
  'v2.signin.emailLink': '… ou avec ton e-mail',
  'v2.signin.disclosure': 'Ton adresse e-mail est alors enregistrée pour la facturation d’un éventuel abonnement.',
  'v2.signin.account.title': 'Garde ta progression',
  'v2.signin.account.description': 'Un compte te permet de retrouver tes grilles sur tous tes appareils. Tu peux continuer à jouer sans.',
  'lobby.players_one': '{{count}} joueur',
  'lobby.players_other': '{{count}} joueurs',
  'clueRail.aria.group': 'Indice actif',
  'clueRail.aria.counter': 'Indice {{index}} sur {{total}}',
  'clueRail.aria.prev': 'Indice précédent',
  'clueRail.aria.next': 'Indice suivant',
  'clueRail.aria.zoomIn': 'Zoomer',
  'clueRail.aria.zoomOut': 'Dézoomer',
  'clueRail.direction.horizontal': 'HORIZONTAL',
  'clueRail.direction.vertical': 'VERTICAL',
  'clueRail.letterCount_one': '{{count}} lettre',
  'clueRail.letterCount_other': '{{count}} lettres',
  'play.aria.timer': 'Temps {{time}}',
  'play.aria.exit': 'Quitter la grille',
  'play.aria.home': 'Accueil',
  'play.aria.settings': 'Réglages',
  'play.hint.aria.remaining': 'Indice — {{remaining}} restants',
  'play.hint.label': 'Indice · {{remaining}}',
  'play.verify.label': 'Vérifier',
  'play.verify.info':
    'Vérifie les lettres que tu as saisies : les bonnes se verrouillent, les autres sont signalées. Disponible toutes les 30 minutes.',
  'play.hint.info':
    'Révèle une lettre de la case active. Un nouvel indice toutes les 10 minutes.',
  'play.results.cta': 'Voir les résultats',
  'play.sound.aria.mute': 'Couper les sons',
  'play.sound.aria.unmute': 'Activer les sons',
  'play.win.aria.dialog': 'Grille terminée',
  'play.win.aria.dismiss': 'Revoir la grille',
  'play.win.headline': 'Grille terminée !',
  'play.win.stat.time': 'Temps',
  'play.win.replay': 'Rejouer',
  'play.win.tomorrow': 'Nouvelle grille demain',
  'play.lockup.kicker': 'WordSparrow · Identité · Lockup',
  'play.lockup.title': 'Icône + titre',
  'play.lockup.lede.pre': 'La tuile-oiseau inclinée associée au mot-symbole bichrome — ',
  'play.lockup.lede.post': ". Horizontal, vertical, puis les trois contextes d’usage.",
  'play.lockup.horizontal.title': 'Horizontal',
  'play.lockup.horizontal.sub': 'icône + nom · côte à côte',
  'play.lockup.appHeaderHint': '≈ en-tête app',
  'play.lockup.fontSpec': 'Fredoka 500 jade · 600 sakura · lettre-espacement −0.015em',
  'play.lockup.vertical.title': 'Vertical',
  'play.lockup.vertical.sub': 'icône au-dessus du nom · empilé',
  'play.lockup.contexts.title': 'Contextes',
  'play.lockup.contexts.sub': "barre d’app · splash · App Store",
  'play.lockup.appBar.label': "Barre d’application",
  'play.lockup.splash.label': 'Écran de lancement',
  'play.lockup.splash.tagline': 'Mots fléchés · chaque jour',
  'play.lockup.appStore.label': 'Fiche App Store',
  'play.lockup.appStore.tagline': 'Mots fléchés quotidiens',
  'play.lockup.appStore.free': 'Gratuit',
  'play.lockup.appStore.category': 'Jeux de mots · 4+',
  'play.lockup.appStore.get': 'Obtenir',
  'auth.avatar.aria.trigger': 'Compte',
  'auth.avatar.account': 'Mon compte',
  'auth.signIn.google': 'Se connecter',
  'auth.signIn.emailLink': '… ou avec ton e-mail',
  'auth.signIn.privacy': 'Confidentialité',
  'auth.assistGate.anon': 'Connecte-toi pour vérifier ta grille.',
  'lobby.aria.hideCode': 'Masquer le code',
  'lobby.aria.showCode': 'Afficher le code',
  'lobby.connection.connecting': 'Connexion en cours…',
  'lobby.connection.disconnected': 'Connexion perdue.',
  'lobby.connection.reconnecting': 'Reconnexion…',
  'lobby.connection.reload': 'Recharger',
  'lobby.endGame.title': 'Bravo ! Grille terminée',
  'lobby.endGame.finalTime': 'Temps final :',
  'lobby.endGame.playAgain': 'Rejouer',
  'lobby.playerList.aria.list': 'Liste des joueurs',
  'lobby.playerList.aria.you': 'toi',
  'lobby.playerList.aria.owner': 'propriétaire',
  'lobby.playerList.aria.typing': "en train d’écrire",
  'lobby.playerList.aria.idle': 'en pause',
  'lobby.playerList.aria.disconnected': 'hors ligne',
  'lobby.playerList.badge.you': 'toi',
  'lobby.playerList.badge.owner': 'propriétaire',
  'lobby.playerList.aria.emptySlot': 'Place libre',
  'lobby.playerList.emptySlot': 'Place libre',
  'lobby.waitingRoom.aria.section': "Salle d’attente",
  'lobby.waitingRoom.playersHeading': 'Joueurs ({{current}}/{{max}})',
  'lobby.waitingRoom.codeLabel': 'Code de partie',
  'lobby.waitingRoom.rotating': 'Régénération…',
  'lobby.waitingRoom.rotateCode': 'Régénérer le code',
  'lobby.waitingRoom.share': 'Partager le lien',
  'lobby.waitingRoom.copy': 'Copier le lien',
  'lobby.waitingRoom.copied': 'Lien copié !',
  'lobby.waitingRoom.starting': 'Démarrage…',
  'lobby.waitingRoom.start': 'Démarrer la partie',
  'lobby.waitingRoom.pseudonymTitle': 'Ton pseudonyme',
  'lobby.waitingRoom.aria.editPseudonym': 'Modifier ton pseudonyme : {{name}}',
  'lobby.waitingRoom.gridSizeLabel': 'Taille de la grille',
  'lobby.myLobbies.heading': 'Mes parties',
  'lobby.myLobbies.empty': 'Tes parties multijoueur en cours apparaîtront ici.',
  'lobby.myLobbies.gameOfDate': 'Partie du {{date}}',
  'lobby.myLobbies.gameFallback': 'Partie',
  'lobby.myLobbies.playerRatio': '{{connected}} / {{total}} joueurs',
  'lobby.myLobbies.aria.share': 'Partager le lien',
  'lobby.myLobbies.aria.copy': 'Copier le lien',
  'lobby.myLobbies.copied': 'Copié',
  'lobby.myLobbies.aria.progress': 'Progression : {{solved}} / {{total}} cases',
  'lobby.leave.aria.delete': 'Supprimer cette partie',
  'lobby.leave.aria.leave': 'Quitter cette partie',
  'lobby.leave.confirm.deleteTitle': 'Supprimer cette partie ?',
  'lobby.leave.confirm.deleteBody': 'Il ne reste personne d’autre dans cette partie : elle sera supprimée définitivement.',
  'lobby.leave.confirm.leaveTitle': 'Quitter cette partie ?',
  'lobby.leave.confirm.leaveBody': 'La partie continue pour les autres joueurs.',
  'lobby.leave.confirm.delete': 'Supprimer',
  'lobby.leave.confirm.leave': 'Quitter',
  'lobby.leave.confirm.cancel': 'Annuler',
  'lobby.leave.processing': 'Traitement…',
  'lobby.leave.error': 'Impossible de quitter la partie. Réessaie.',
  'lobby.delete.error': 'Impossible de supprimer la partie. Réessaie.',
  'lobby.list.retentionNote': 'Les parties inactives sont supprimées automatiquement après plusieurs jours.',
  'lobby.sr.playerJoined': '{{name}} a rejoint la partie',
  'lobby.sr.playerLeft': '{{name}} a quitté la partie',
  'lobby.sr.unknownPlayer': 'Un joueur',
  'lobby.sr.gameStarted': 'La partie commence',
  'lobby.sr.wordLocked': 'mot validé : {{word}}',
  'lobby.toast.reconnected': 'Connexion rétablie',
  'lobby.toast.connectionLost': 'Connexion perdue — reconnexion en cours…',
  'lobby.error.joinDenied': 'Code invalide ou partie privée. Demande le code à l’organisateur.',
  'lobby.error.cannotJoin': 'Impossible de rejoindre cette partie. Réessaie.',
  'lobby.error.cannotStart': 'Impossible de démarrer la partie. Réessaie.',
  'lobby.error.generic': 'Une erreur est survenue. Réessaie.',
  'error.api.network': "Connexion impossible. Vérifie ton réseau et réessaie.",
  'error.api.generic': "Une erreur est survenue. Réessaie.",
  'appHeader.skip.grid': 'Aller à la grille',
  'appHeader.skip.content': 'Aller au contenu',
  'appHeader.aria.home': 'Accueil WordSparrow',
  'appHeader.aria.versionAlpha': 'version alpha',
  'appHeader.aria.nav': 'Navigation principale',
  'appHeader.menu.open': 'Ouvrir le menu',
  'appHeader.nav.home': 'Accueil',
  'appHeader.nav.grids': 'Grilles',
  'appHeader.nav.contribute': 'Contribuer',
  'appHeader.nav.help': 'Aide',
  'footer.contact': 'Contact',
  'timerPill.aria.label': 'temps écoulé',
  'keyboard.aria.panel': 'Clavier mots fléchés',
  'keyboard.aria.cursorUp': 'Curseur haut',
  'keyboard.aria.cursorDown': 'Curseur bas',
  'keyboard.aria.cursorLeft': 'Curseur gauche',
  'keyboard.aria.cursorRight': 'Curseur droite',
  'keyboard.aria.letter': 'Lettre {{letter}}',
  'keyboard.aria.hint': 'Demander un indice, {{remaining}} restants',
  'keyboard.aria.backspace': 'Effacer',
  'clueBanner.empty': 'Touche une case pour commencer',
  'clueBanner.aria.definition': 'définition {{direction}}',
  'clueBanner.aria.toggle': 'Basculer sur la définition {{direction}}',
  'clueBanner.aria.alternate': 'alternative : définition {{direction}}',
  'compte.contributions.error': 'Impossible de charger tes contributions.',
  'compte.contributions.empty': "Tu n’as encore proposé aucune correction.",
  'compte.contributions.coverage': 'couverture :',
  'compte.contributions.optedOut': '(sera supprimée en cas de suppression du compte)',
  'compte.survey.legend': 'Confidentialité du sondage',
  'compte.survey.deleteOnErasure':
    'Supprimer aussi mes corrections proposées en cas de suppression de mon compte.',
  'compte.survey.saved': 'Enregistré',
  'tour.skip': 'Passer le tour',
  'tour.action.next': 'Suivant',
  'tour.action.prev': 'Précédent',
  'tour.action.finish': 'Terminer',
  'tour.progress': 'Étape {{current}} sur {{total}}',
  'tour.welcome.title': 'Bienvenue',
  'tour.welcome.body':
    'Quelques secondes pour découvrir comment jouer aux mots fléchés. Tu peux passer le tour à tout moment.',
  'tour.clueCells.title': "Cases d’indices",
  'tour.clueCells.body': 'Les cases roses contiennent les définitions du mot à trouver.',
  'tour.arrows.title': 'Suis les flèches',
  'tour.arrows.body':
    'Une petite flèche indique la direction et la première case de la réponse — → pour les mots horizontaux, ↓ pour les verticaux.',
  'tour.hints.title': 'Coup de pouce',
  'tour.hints.body':
    "Bloqué·e sur un mot ? Le bouton d’aide dans le bandeau te donne un coup de main. Il se recharge après chaque utilisation.",
  'tour.zoom.title': 'Ajuster le zoom',
  'tour.zoom.body':
    'Trois boutons sous la grille pour zoomer ou revenir à la vue de départ. La molette de la souris ajuste aussi le zoom — pratique pour confirmer une lettre serrée.',
  'tour.validation.title': 'Aperçu de la grille',
  'tour.validation.body':
    "L’aperçu de la grille suit ton avancée et met en évidence les cases déjà remplies.",
  'grid.clue.empty': 'Sélectionne une case pour afficher la définition',
  'grid.clue.aria.switch': 'Basculer sur la définition {{direction}} (raccourci : Espace)',
  'grid.clue.aria.twoDefinitions': 'deux définitions',
  'grid.clue.switchKey': 'Espace',
  'grid.wordEntry.direction.horizontal': 'horizontal',
  'grid.wordEntry.direction.vertical': 'vertical',
  'grid.wordEntry.emptyCell': 'point',
  'grid.sr.wordEntry': '« {{clue}} », mot {{direction}} de {{length}} lettres : {{pattern}}',
  'grid.minimap.aria.label': 'Aperçu de la grille — la zone surlignée indique la partie visible',
  'grid.zoom.aria.controls': 'Contrôles du zoom',
  'grid.zoom.aria.out': 'Dézoomer',
  'grid.zoom.aria.reset': 'Réinitialiser le zoom',
  'grid.zoom.aria.in': 'Zoomer',
  'grid.scrollbar.aria.vertical': 'Défilement vertical de la grille',
  'grid.scrollbar.aria.horizontal': 'Défilement horizontal de la grille',
  'grid.hint.error.exhausted': 'Indices épuisés',
  'grid.hint.error.authRequired': 'Connecte-toi pour utiliser les indices',
  'grid.hint.error.generic': 'Une erreur est survenue. Réessaie.',
  'grid.verify.error.cooldown': 'Vérification bientôt disponible',
  'grid.verify.error.authRequired': 'Connecte-toi pour vérifier ta grille',
  'grid.verify.error.generic': 'Erreur, réessayez',
  'grid.verify.cooldown.label': '{{time}}',
  'grid.verify.cooldown.available': 'Nouvelle vérification disponible.',
  'sondage.field.nature': 'Nature',
  'sondage.field.style': 'Style',
  'sondage.field.categories': 'Catégories',
  'sondage.field.sens': 'Sens',
  'sondage.field.motscles': 'Mots-clés',
  'sondage.difficulte': 'Difficulté',
  'sondage.aria.natureGrammaticale': 'Nature grammaticale',
  'sondage.difficulty.aria.scoreOfFive': '{{score}} sur 5',
  'sondage.verdict.passer': 'Passer',
  'sondage.categorie.sr.removed': '{{label}} retirée',
  'sondage.categorie.sr.added': '{{label}} ajoutée',
  'sondage.categorie.sr.exclusiveSelected': '{{label}} sélectionnée, autres catégories retirées',
  'sondage.categorie.sr.addedExclusiveRemoved': '{{label}} ajoutée, {{other}} retirée',
  'sondage.band.overline': 'Métadonnées',
  'sondage.band.overlineNote': '· optionnel, aide l’entraînement',
  'sondage.band.badge.saved': '✓ Enregistré',
  'sondage.band.badge.modified': '✦ Modifié · à enregistrer',
  'sondage.band.badge.pristine': '✦ Pré-rempli · à vérifier',
  'sondage.band.primary.saved': 'Enregistré',
  'sondage.band.primary.pristine': 'Confirmer',
  'sondage.band.kbd.space': 'Espace',
  'sondage.band.reset': 'Réinitialiser',
  'sondage.band.aria.removeCategoriePrefilled': 'Retirer {{label}} (pré-remplie)',
  'sondage.band.aria.removeCategorieAdded': 'Retirer {{label}} (ajoutée)',
  'sondage.band.aria.addCategorie': 'Ajouter {{label}}',
  'sondage.band.categories.expand': '+ Toutes les catégories ▾',
  'sondage.band.categories.collapse': '– Réduire les catégories ▴',
  'sondage.band.sens.label': 'Sens visé par cette définition',
  'sondage.band.sens.aria.edit': 'Modifier le sens — {{sense}}',
  'sondage.band.sens.aria.add': 'Ajouter le sens — vide',
  'sondage.band.sens.empty': '+ préciser le sens…',
  'sondage.band.sens.placeholder': 'ex. saison entre l’été et l’hiver…',
  'sondage.band.motscles.aria.edit': 'Modifier les mots-clés — {{tags}}',
  'sondage.band.motscles.aria.add': 'Ajouter des mots-clés — vide',
  'sondage.band.motscles.placeholder': '+ ajouter…',
  'sondage.rating.corriger': 'Corriger la définition',
  'sondage.rating.correctif.label': 'Définition corrigée',
  'sondage.rating.correctif.hint': 'Soumise comme nouvelle entrée, automatiquement notée « bonne ».',
  'sondage.rating.correctif.submit': 'Soumettre la correction',
  'sondage.rating.aria.verdict': 'Verdict',
  'sondage.rating.aria.bad': "Mauvaise définition pour l’indice « {{definition}} »",
  'sondage.rating.aria.skip': "Passer l’indice « {{definition}} »",
  'sondage.rating.aria.good': "Bonne définition pour l’indice « {{definition}} »",
  'sondage.rating.verdict.bad': 'Mauvaise',
  'sondage.rating.verdict.good': 'Bonne',
  'sondage.rating.signaler': 'Signaler',
  'sondage.pair.difficultyAnnounced': 'Difficulté annoncée',
  'sondage.pair.aria.left': 'Définition de gauche',
  'sondage.pair.heading.left': 'Gauche',
  'sondage.pair.aria.right': 'Définition de droite',
  'sondage.pair.heading.right': 'Droite',
  'sondage.pair.aria.compare': 'Comparaison des deux définitions',
  'sondage.pair.aria.preferLeft': 'Préférer la définition de gauche',
  'sondage.pair.verdict.left': '← Préférer celle-ci',
  'sondage.pair.aria.preferRight': 'Préférer la définition de droite',
  'sondage.pair.verdict.right': 'Préférer celle-ci →',
  'sondage.pair.aria.bothBad': 'Les deux définitions sont mauvaises',
  'sondage.pair.verdict.bothBad': 'Les deux mauvaises',
  'sondage.pair.aria.skip': 'Passer cette paire',
  'sondage.pair.aria.bothGood': 'Les deux définitions sont bonnes',
  'sondage.pair.verdict.bothGood': 'Les deux bonnes',
  'sondage.gloss.sr.added': 'Ajouté : {{value}}',
  'sondage.gloss.sr.removed': 'Retiré : {{value}}',
  'sondage.gloss.aria.removeChip': 'Retirer {{value}}',
  'sondage.sense.repeatError': 'Le sens ne doit pas répéter le mot.',
  'sondage.correctif.title': 'Proposer une meilleure définition (optionnel)',
  'sondage.correctif.altLabel': 'Définition alternative',
  'sondage.correctif.placeholder': 'ex. animal domestique à moustaches',
  'sondage.correctif.styleLabel': 'Style proposé',
  'sondage.correctif.notice': 'Les corrections proposées rejoignent notre corpus comme indices anonymes, sans lien avec ton compte.',
  'sondage.signIn.aria.banner': 'Invitation à se connecter',
  'sondage.signIn.text': 'Connecte-toi pour proposer tes propres indices et suivre tes contributions.',
  'sondage.signIn.disclosure': 'Ton adresse e-mail est alors enregistrée pour la facturation d’un éventuel abonnement.',
  'sondage.signIn.cta': 'Se connecter',
  'sondage.signIn.emailLink': '… ou avec ton e-mail',
  'sondage.style.prefix': 'Style : ',
  'sondage.style.aria.moreInfo': 'En savoir plus sur le style {{label}}',
  'sondage.style.header': 'Style : {{label}}',
  'sondage.style.example': 'Exemple',
  'sondage.style.exampleLine': '« {{definition}} » → {{mot}}',
  'sondage.undo.status': 'Action enregistrée.',
  'sondage.lockBanner': 'Campagne en pause — un nouveau lot est en cours d’entraînement. Reviens bientôt pour la suite.',
  'v2.multiplayer.leave': 'Quitter',
  'v2.multiplayer.play': 'Jouer',
  'v2.multiplayer.creating': 'Création…',
  'v2.multiplayer.host.badge': 'Hôte',
  'v2.multiplayer.presence.online': 'en ligne',
  'v2.multiplayer.presence.typing': 'en train d’écrire',
  'v2.multiplayer.presence.connected': 'en ligne',
  'v2.multiplayer.presence.connecting': 'connexion',
  'v2.multiplayer.presence.youSuffix': ' (toi)',
  'v2.multiplayer.presence.aria.players': 'Joueurs',
  'v2.multiplayer.presence.aria.status': '{{name}} : {{status}}',
  'v2.multiplayer.presence.aria.score_one': '{{name}} : {{count}} lettre validée',
  'v2.multiplayer.presence.aria.score_other': '{{name}} : {{count}} lettres validées',
  'v2.multiplayer.coop.ownerless': 'Cette partie n’a plus d’hôte',
  'v2.multiplayer.coop.sr.solved': 'Grille résolue !',
  'v2.multiplayer.coop.claim': 'Reprendre la partie',
  'v2.multiplayer.coop.claiming': 'Reprise…',
  'v2.multiplayer.coop.aria.leaveGame': 'Quitter la partie',
  'v2.multiplayer.owned.title': 'Tu as déjà une partie en cours',
  'v2.multiplayer.owned.description': 'Le niveau gratuit autorise une seule partie active à la fois. Rejoins-la, ou reprends à zéro.',
  'v2.multiplayer.owned.rejoin': 'Rejoindre ma partie',
  'v2.multiplayer.owned.startNew': 'Démarrer une nouvelle partie',
  'v2.multiplayer.owned.subscriberHint': 'Les abonnés peuvent créer plusieurs parties en même temps.',
  'v2.multiplayer.owned.learnMore': 'En savoir plus',
  'v2.multiplayer.salon.title': 'Partie',
  'v2.multiplayer.salon.lead': 'Invite tes amis, puis lance la grille ensemble.',
  'v2.multiplayer.salon.rotate': 'Nouveau code',
  'v2.multiplayer.salon.rotating': 'Nouveau code…',
  'v2.multiplayer.salon.aria.pseudonymField': 'Ton pseudonyme',
  'v2.multiplayer.salon.changePseudo': 'Changer mon pseudo',
  'v2.multiplayer.resultats.title': 'Résolue !',
  'v2.multiplayer.resultats.subtitle': 'Grille bouclée ensemble. Belle équipe !',
  'v2.multiplayer.resultats.timeLabel': 'Temps',
  'v2.multiplayer.resultats.aria.timeSection': 'Temps final',
  'v2.multiplayer.resultats.aria.finalTime': 'Temps final {{time}}',
  'v2.multiplayer.resultats.aria.participants': 'Participants',
  'v2.multiplayer.resultats.withCount': 'Avec ({{total}})',
  'v2.multiplayer.resultats.letterCount_one': '{{count}} lettre',
  'v2.multiplayer.resultats.letterCount_other': '{{count}} lettres',
  'v2.multiplayer.resultats.home': "Retour à l’accueil",
  'v2.multiplayer.resultats.autoRestart': 'Nouvelle partie dans {{seconds}}s…',
  'v2.multiplayer.resultats.rematchNow': 'Rejouer maintenant',
  'v2.multiplayer.resultats.cancelRematch': 'Annuler',
  'v2.abonnement.tier.complet': 'Accès complet',
  'v2.abonnement.tier.gratuit': 'Gratuit',
  'v2.abonnement.tier.gratuite': 'Version gratuite',
  'v2.abonnement.cadence.mensuel.label': 'Mensuel',
  'v2.abonnement.cadence.mensuel.note': 'Tu arrêtes quand tu veux',
  'v2.abonnement.cadence.mensuel.suffix': '/mois',
  'v2.abonnement.cadence.annuel.label': 'Annuel',
  'v2.abonnement.cadence.annuel.note': 'Deux mois offerts',
  'v2.abonnement.cadence.annuel.suffix': '/an',
  'v2.abonnement.recap.mensuel.period': 'par mois',
  'v2.abonnement.recap.mensuel.renewal': 'Reconduction tacite chaque mois',
  'v2.abonnement.recap.annuel.period': 'par an',
  'v2.abonnement.recap.annuel.renewal': 'Reconduction tacite chaque année',
  'v2.abonnement.feature.complet.all': 'Toutes les grilles, sans limite',
  'v2.abonnement.feature.complet.history': "Tout l’historique, jusqu’à la première",
  'v2.abonnement.feature.complet.generate': 'Génère de nouvelles grilles quand tu veux',
  'v2.abonnement.feature.complet.future': 'Et les nouveautés à venir',
  'v2.abonnement.feature.gratuit.daily': 'La grille du jour',
  'v2.abonnement.feature.gratuit.week': 'Les 7 derniers jours',
  'v2.abonnement.feature.gratuit.started': 'Tes grilles déjà commencées',
  'v2.abonnement.error.alreadySubscribed': 'Tu as déjà un abonnement actif.',
  'v2.abonnement.error.authRequired': 'Connecte-toi pour gérer ton abonnement.',
  'v2.abonnement.error.providerUnavailable':
    'Le service de paiement est momentanément indisponible. Réessaie dans un instant.',
  'v2.abonnement.error.rateLimited': 'Trop de tentatives. Réessaie dans un instant.',
  'v2.abonnement.error.generic': 'Une erreur est survenue. Réessaie.',
  'v2.abonnement.selector.aria.group': 'Formule',
  'v2.abonnement.subscribed.title': 'Tu es abonné·e',
  'v2.abonnement.subscribed.body':
    'Tu as accès à toutes les grilles et à la génération. Gère ton abonnement dans Réglages.',
  'v2.abonnement.subscribed.manage': 'Aller aux Réglages',
  'v2.abonnement.offer.heroTitle': 'Joue toutes les grilles',
  'v2.abonnement.offer.heroSub': "Débloque tout l’historique et génère de nouvelles grilles quand tu veux.",
  'v2.abonnement.offer.ethos':
    "Le jeu reste entièrement gratuit. L’abonnement débloque l’Accès complet : toutes les grilles et la génération.",
  'v2.abonnement.recap.aria': 'Récapitulatif',
  'v2.abonnement.recap.title': 'Ton récapitulatif',
  'v2.abonnement.recap.key.offre': 'Offre',
  'v2.abonnement.recap.key.prix': 'Prix',
  'v2.abonnement.recap.key.premierPrelevement': 'Premier prélèvement',
  'v2.abonnement.recap.val.aujourdhui': "Aujourd’hui",
  'v2.abonnement.recap.key.reconduction': 'Reconduction',
  'v2.abonnement.recap.note':
    "Ton accès est immédiat. L’abonnement se renouvelle tout seul {{period}} ; tu résilies quand tu veux depuis tes Réglages.",
  'v2.abonnement.consent.cgv.text': "J’accepte les",
  'v2.abonnement.consent.cgv.link': 'Conditions de vente',
  'v2.abonnement.consent.waiver':
    "Je demande l’accès immédiat au contenu et je reconnais renoncer à mon droit de rétractation de 14 jours.",
  'v2.abonnement.cta.signIn': "Se connecter pour s’abonner",
  'v2.abonnement.cta.confirm': 'Confirmer et payer',
  'v2.abonnement.cta.subscribe': "S’abonner",
  'v2.abonnement.confirmHint': 'Étape de confirmation : vérifie ton récapitulatif, puis confirme pour payer.',
  'v2.abonnement.confirm.modify': 'Modifier',
  'v2.abonnement.plan.gratuit.tag': 'Inclus pour tous',
  'v2.abonnement.reassure': 'Paiement sécurisé · sans engagement · résiliable à tout moment',
  'v2.abonnement.unavailable': "L’abonnement n’est pas disponible pour le moment.",
  'v2.abonnement.section.title': 'Ton abonnement',
  'v2.abonnement.loading': 'Chargement de ton abonnement…',
  'v2.abonnement.loadError': 'Impossible de charger ton abonnement pour le moment.',
  'v2.abonnement.period.renewal': 'Renouvellement le {{date}}',
  'v2.abonnement.period.activeUntil': "Accès actif jusqu’au {{date}}",
  'v2.abonnement.period.ended': 'Terminé le {{date}}',
  'v2.abonnement.status.actif': 'Actif',
  'v2.abonnement.status.pastDue': 'Paiement en attente',
  'v2.abonnement.status.pending': 'Résilié',
  'v2.abonnement.status.expire': 'Terminé',
  'v2.abonnement.cancel.error.noActive': "Tu n’as pas d’abonnement actif à résilier.",
  'v2.abonnement.cancel.error.generic': 'La résiliation a échoué. Réessaie dans un instant.',
  'v2.abonnement.reactivate.error.noActive': "Il n’y a pas d’abonnement à reprendre.",
  'v2.abonnement.reactivate.error.providerUnavailable':
    'Le service est momentanément indisponible. Réessaie dans un instant.',
  'v2.abonnement.reactivate.error.generic': 'La reprise a échoué. Réessaie dans un instant.',
  'v2.abonnement.pastDue.note':
    'Paiement en attente — ton dernier prélèvement a échoué. On réessaie automatiquement, et tu gardes ton accès en attendant. Si le problème persiste, écris-nous à',
  'v2.abonnement.cancel.trigger': "Résilier l’abonnement",
  'v2.abonnement.pending.note':
    "Tu gardes l’accès jusqu’à la fin de la période. Rien ne te sera plus prélevé ensuite. Tu reprends là où tu t’étais arrêté, sans nouveau paiement.",
  'v2.abonnement.reactivate.pending': 'Reprise…',
  'v2.abonnement.reactivate.cta': 'Reprendre mon abonnement',
  'v2.abonnement.expire.note':
    "Ton abonnement s’est terminé — la grille du jour, les 7 derniers jours et tes grilles commencées restent à toi. Reviens quand tu veux, sans pression.",
  'v2.abonnement.expire.cta': 'Me réabonner',
  'v2.abonnement.free.note':
    "Tu joues avec la version gratuite. L’abonnement débloque toutes les grilles et la génération.",
  'v2.abonnement.free.cta': "Découvre l’abonnement",
  'v2.abonnement.cancelDialog.title': 'Résilier ton abonnement ?',
  'v2.abonnement.cancelDialog.body':
    "Tu gardes l’accès jusqu’à la fin de la période en cours. Rien ne te sera plus prélevé ensuite — tu pourras te réabonner quand tu veux.",
  'v2.abonnement.cancelDialog.confirming': 'Résiliation…',
  'v2.abonnement.cancelDialog.confirm': 'Oui, résilier',
  'v2.abonnement.cancelDialog.keep': 'Annuler',
  'v2.abonnement.annule.title': 'Paiement annulé',
  'v2.abonnement.annule.status': "Aucun montant n’a été débité.",
  'v2.abonnement.annule.lede':
    "WordSparrow reste gratuit. Si tu changes d’avis, tu peux relancer l’abonnement quand tu veux.",
  'v2.abonnement.annule.back': 'Revenir à mon abonnement',
  'v2.abonnement.sheet.grid.title': 'Une grille réservée aux abonnés',
  'v2.abonnement.sheet.grid.text':
    "Abonne-toi pour jouer toutes les grilles et tout l’historique. La grille du jour et les 7 derniers jours restent gratuits.",
  'v2.abonnement.sheet.generate.title': 'Génère une nouvelle grille',
  'v2.abonnement.sheet.generate.text':
    "Une grille fraîche dès que l’envie te prend, autant que tu veux. C’est compris dans l’abonnement.",
  'v2.abonnement.sheet.cta': "Voir l’abonnement",
  'v2.abonnement.succes.kicker': 'Abonnement activé',
  'v2.abonnement.succes.title': 'Te voilà abonné·e !',
  'v2.abonnement.succes.body': 'Toutes les grilles sont à toi, et tu peux en générer de nouvelles quand tu veux.',
  'v2.abonnement.succes.receipt': 'Un reçu te sera envoyé par e-mail.',
  'v2.abonnement.succes.cta': 'Découvrir toutes les grilles',
  'v2.abonnement.succes.heading': 'Abonnement',
  'v2.abonnement.succes.timeout':
    "La confirmation prend plus de temps que prévu. Aucune action n’est nécessaire : ton accès s’activera dès que le paiement sera confirmé.",
  'v2.abonnement.succes.confirming': 'Paiement reçu, confirmation en cours…',
  'v2.abonnement.succes.backCompte': 'Retour à mon compte',
  'v2.abonnement.receipt.status.paid': 'Payé',
  'v2.abonnement.receipt.status.pending': 'En attente',
  'v2.abonnement.receipt.status.authorized': 'Autorisé',
  'v2.abonnement.receipt.status.failed': 'Échoué',
  'v2.abonnement.receipt.status.expired': 'Expiré',
  'v2.abonnement.receipt.status.canceled': 'Annulé',
  'v2.abonnement.receipt.status.refunded': 'Remboursé',
  'v2.abonnement.receipt.section.title': 'Mes reçus',
  'v2.abonnement.receipt.loading': 'Chargement de tes reçus…',
  'v2.abonnement.receipt.loadError': 'Impossible de charger tes reçus pour le moment.',
  'v2.abonnement.receipt.empty': 'Aucun reçu pour le moment.',
  'v2.abonnement.receipt.more': 'Voir plus',
  'v2.abonnement.upsell.title': 'Débloque toutes les grilles',
  'v2.abonnement.upsell.home': 'Abonne-toi et joue sans limite',
  'v2.abonnement.upsell.archive': "Tout l’historique et les nouvelles grilles",
  'v2.compte.title': 'Mon compte',
  'v2.compte.sync.idle.sub': 'Récupère ta progression sur cet appareil',
  'v2.compte.sync.syncing.sub': 'Synchronisation…',
  'v2.compte.sync.done.sub': 'Ta progression est à jour',
  'v2.compte.sync.error.sub': 'Échec — réessaie',
  'v2.compte.sync.syncing.announce': 'Synchronisation en cours',
  'v2.compte.sync.done.announce': 'Synchronisation terminée',
  'v2.compte.sync.error.announce': 'La synchronisation a échoué',
  'v2.compte.profileLoadError': 'Impossible de charger les détails du profil. Réessaie plus tard.',
  'v2.compte.name.invalid': 'Ce pseudonyme n’est pas valide.',
  'v2.compte.name.updateFailed': 'La mise à jour a échoué. Réessaie.',
  'v2.compte.logoutAllDone': 'Déconnecté·e de tous les appareils.',
  'v2.compte.aria.pseudonym': 'Pseudonyme',
  'v2.compte.aria.editPseudonym': 'Modifier le pseudonyme',
  'v2.compte.meta.subscribed': 'Connecté · Abonné·e',
  'v2.compte.meta.connected': 'Connecté',
  'v2.compte.group.facturation': 'Facturation',
  'v2.compte.email.label': 'Adresse e-mail',
  'v2.compte.email.empty': 'Non renseignée',
  'v2.compte.email.note': 'Utilisée uniquement pour la facturation.',
  'v2.compte.group.progression': 'Progression',
  'v2.compte.sync.action': 'Synchroniser maintenant',
  'v2.compte.group.connexion': 'Connexion',
  'v2.compte.google.label': 'Google',
  'v2.compte.google.connected': 'Compte connecté',
  'v2.compte.google.disconnected': 'Non connecté',
  'v2.compte.logoutAll': 'Se déconnecter de tous les appareils',
  'v2.compte.group.dataAria': 'Données',
  'v2.compte.group.data': 'Tes données',
  'v2.compte.signIn.lede': 'Connecte-toi pour retrouver ta progression sur tous tes appareils.',
  'v2.compte.signIn.connecting': 'Connexion…',
  'v2.compte.signIn.google': 'Se connecter avec Google',
  'v2.compte.signIn.emailLink': '… ou connecte-toi avec ton adresse e-mail',
  'v2.compte.signIn.disclosure': 'En te connectant, ton adresse e-mail est enregistrée pour la facturation d’un éventuel abonnement.',
  'v2.reglages.title': 'Réglages',
  'v2.reglages.theme.clair': 'Clair',
  'v2.reglages.theme.sombre': 'Sombre',
  'v2.reglages.appearance': 'Apparence',
  'v2.reglages.aria.theme': 'Thème',
  'v2.reglages.sound': 'Son',
  'v2.reglages.sound.label': 'Sons',
  'v2.reglages.sound.sub': 'Effets sonores de la grille',
  'v2.reglages.grid': 'Grille',
  'v2.reglages.grid.skipFilled.label': 'Sauter les cases déjà remplies',
  'v2.reglages.grid.skipFilled.sub': 'Après une lettre, le curseur saute à la prochaine case vide',
  'v2.reglages.account.loading': 'Chargement du compte',
  'v2.reglages.profile.seeAccount': 'Voir mon compte',
  'v2.reglages.profile.guest': 'Invité',
  'v2.reglages.profile.noAccount': 'Sans compte',
  'v2.reglages.app': 'Application',
  'v2.reglages.install.label': "Installer l’application",
  'v2.reglages.install.sub': "Sur ton écran d’accueil",
  'v2.reglages.about': 'À propos',
  'v2.reglages.about.privacy': 'Confidentialité',
  'v2.reglages.about.legal': 'Mentions légales',
  'v2.reglages.about.terms': 'Conditions de vente',
  'v2.reglages.help': 'Aide',
  'v2.reglages.help.shortcuts': 'Aide & raccourcis',
  'v2.reglages.help.contact': 'Nous écrire',
  'v2.reglages.foot': 'WordSparrow · fait avec soin 🐦',
  'v2.connexion.error.cooldown': 'Trop de tentatives. Réessaie dans une minute.',
  'v2.connexion.error.invalidEmail': 'Cette adresse e-mail n’est pas valide.',
  'v2.connexion.error.sendFailed': 'L’envoi a échoué. Réessaie.',
  'v2.connexion.error.verifyFailed': 'La vérification a échoué. Réessaie.',
  'v2.connexion.error.codeInvalid': 'Code incorrect ou expiré.',
  'v2.connexion.sr.codeSent': 'Code envoyé par e-mail.',
  'v2.connexion.sr.success': 'Connexion réussie.',
  'v2.connexion.title': 'Connexion',
  'v2.connexion.lede': 'Entre ton adresse e-mail : on t’envoie un code à six chiffres pour te connecter, sans mot de passe.',
  'v2.connexion.emailLabel': 'Adresse e-mail',
  'v2.connexion.emailPlaceholder': 'toi@exemple.fr',
  'v2.connexion.sending': 'Envoi…',
  'v2.connexion.submit': 'Recevoir le code',
  'v2.connexion.code.title': 'Ton code',
  'v2.connexion.code.ledePre': 'On a envoyé un code à ',
  'v2.connexion.code.ledePost': '. Saisis-le ci-dessous pour te connecter.',
  'v2.connexion.otpLabel': 'Code de connexion',
  'v2.connexion.resend': 'Renvoyer le code',
  'v2.connexion.editEmail': 'Modifier l’adresse e-mail',
  'v2.erase.title': 'Effacer mes données',
  'v2.erase.desc.pre': 'Cette action est définitive et irréversible. Tape ton pseudonyme (',
  'v2.erase.desc.post': ') pour confirmer.',
  'v2.erase.aria.confirm': 'Confirmation du pseudonyme',
  'v2.erase.failed': 'La suppression a échoué. Réessaie.',
  'v2.erase.deleting': 'Suppression…',
  'v2.erase.confirm': 'Effacer définitivement',
  'v2.apropos.title': "À propos",
  'v2.apropos.lede': "Un petit jeu de mots fléchés à la française, fait avec soin.",
  'v2.apropos.projet.heading': "Le projet",
  'v2.apropos.projet.p1.pre': "Je m’appelle ",
  'v2.apropos.projet.p1.post': " et je développe WordSparrow seul, en France.",
  'v2.apropos.projet.p2': "C’est autant un jeu qu’un terrain d’apprentissage : je le fais pour progresser, pour le plaisir du travail soigné, et avec l’envie qu’on ait plaisir à l’ouvrir chaque matin. Pas de grande équipe derrière — deux mains, beaucoup de patience.",
  'v2.apropos.ia.heading': "L’intelligence artificielle",
  'v2.apropos.ia.p1': "Autant être clair sur la fabrication des définitions : elles sont rédigées par un modèle de langage, que j’entraîne et affine au fil du temps. Le résultat n’est pas encore parfait — il reste des définitions maladroites — et je continue de le peaufiner.",
  'v2.apropos.ia.p2': "L’IA me permet de faire vivre le projet à moindre coût, le temps qu’il trouve son public. Le jour où WordSparrow gagnera de l’argent, je veux le consacrer à de vraies plumes : des auteurs payés pour écrire les définitions.",
  'v2.apropos.ia.p3': "Tout ça a un coût pour l’environnement — de l’énergie, de l’eau. Je n’ai pas de chiffres à te vendre, mais les définitions sont générées une fois, par lots, puis figées.",
  'v2.apropos.thanks.heading': "Remerciements",
  'v2.apropos.thanks.p1': "WordSparrow ne tient pas debout tout seul. Il repose sur des logiciels libres et sur des polices d’écriture offertes à tous.",
  'v2.apropos.thanks.p2': "Rien de tout cela ne nous appartient vraiment : on en hérite, et on essaie d’en prendre soin. Voici celles et ceux à qui l’on doit un grand merci.",
  'v2.apropos.code.heading': "Le code et les outils",
  'v2.apropos.code.p1': "Le jeu tourne grâce à des logiciels libres, écrits et entretenus par une foule de gens qu’on ne croisera jamais.",
  'v2.apropos.code.p2.pre': "Ils sont bien trop nombreux pour tenir ici : ",
  'v2.apropos.code.p2.link': "la liste complète des licences",
  'v2.apropos.code.p2.post': " les cite un à un.",
  'v2.apropos.letters.heading': "Les lettres",
  'v2.apropos.letters.p1': "Les mots méritent de belles lettres. Nos polices d’écriture ont été dessinées puis partagées librement, sous licence SIL Open Font, par des créateurs typographiques.",
  'v2.apropos.letters.p2.pre': "Merci aux polices ",
  'v2.apropos.letters.p2.et': " et ",
  'v2.apropos.letters.p2.post': ", et aux mains patientes qui les ont tracées.",
  'v2.apropos.langue.heading': "La langue et les mots",
  'v2.apropos.langue.p1': "Sans dictionnaire, pas de grille. Notre vocabulaire vient d’un long travail de recensement du français, mot après mot, année après année.",
  'v2.apropos.langue.p2.pre': "Merci à ",
  'v2.apropos.langue.p2.mid1': " et à son dictionnaire français, au ",
  'v2.apropos.langue.p2.mid2': ", et à ",
  'v2.apropos.langue.p2.post': ", le Wiktionnaire mis en données ouvertes.",
  'v2.aide.eyebrow': "Besoin d’un coup de main ?",
  'v2.aide.title': "Aide",
  'v2.aide.lede': "L’essentiel pour jouer, en quelques mots.",
  'v2.aide.kbd.espace': "Espace",
  'v2.aide.kbd.retour': "Retour",
  'v2.aide.play.heading': "Comment jouer",
  'v2.aide.play.pre': "Touche une case puis tape une lettre. Les flèches du clavier te déplacent dans la grille en évitant les cases d’indices. Au carrefour de deux mots, appuie sur ",
  'v2.aide.play.post': " pour basculer entre les deux directions.",
  'v2.aide.shortcuts.heading': "Raccourcis clavier",
  'v2.aide.shortcuts.move': " pour te déplacer, ",
  'v2.aide.shortcuts.direction': " pour changer de direction à un carrefour, ",
  'v2.aide.shortcuts.erase': " pour effacer une lettre, et ",
  'v2.aide.shortcuts.next': " pour passer au mot suivant.",
  'v2.aide.validation.heading': "Coup de pouce",
  'v2.aide.validation.body': "Si tu bloques sur un mot, un bouton d’aide dans le bandeau te donne un coup de main. Il se recharge après chaque utilisation, alors garde-le pour les moments où tu en as vraiment besoin.",
  'v2.aide.multi.heading': "Jouer à plusieurs",
  'v2.aide.multi.body': "Crée une partie à plusieurs depuis l’accueil et partage le lien : tout le monde joue la même grille, en même temps.",
  'v2.aide.install.heading': "Installer l’application",
  'v2.aide.install.body': "WordSparrow s’installe comme une app : grille en plein écran, lancement depuis ton écran d’accueil. Sur Android et sur ordinateur, passe par « Installer l’application » dans les Réglages. Sur iPhone et iPad : bouton Partager de Safari, puis « Sur l’écran d’accueil ».",
  'v2.confidentialite.title': "Confidentialité",
  'v2.confidentialite.lede': "On garde les choses simples : le minimum de données, jamais de revente, et tu gardes la main.",
  'v2.confidentialite.collecte.heading': "Ce que l’on collecte",
  'v2.confidentialite.collecte.p1.pre': "Ta progression de jeu (mots trouvés, séries) est enregistrée ",
  'v2.confidentialite.collecte.p1.strong': "sur ton appareil",
  'v2.confidentialite.collecte.p1.post': ". Si tu as un compte, elle est aussi synchronisée sur ton compte pour te suivre d’un appareil à l’autre. On mesure des stats d’usage anonymes pour améliorer le jeu.",
  'v2.confidentialite.collecte.pill.local': "Progression locale",
  'v2.confidentialite.collecte.pill.stats': "Stats anonymes",
  'v2.confidentialite.cookies.heading': "Cookies",
  'v2.confidentialite.cookies.p1': "Aucun cookie publicitaire ni traceur tiers. La mesure d’audience est anonyme et sans cookie : adresse IP tronquée, aucun recoupement entre sites, et le signal « Ne pas me pister » (Do Not Track) de ton navigateur est respecté.",
  'v2.confidentialite.cookies.p2': "Cette mesure relève de l’exemption de consentement prévue par la CNIL : il n’y a donc pas de bandeau cookies à accepter.",
  'v2.confidentialite.facturation.heading': "Facturation et paiement",
  'v2.confidentialite.facturation.p1': "Quand tu te connectes, ton adresse e-mail est enregistrée — au titre d’une obligation légale et de l’exécution du contrat. Si tu prends un abonnement, elle sert à t’envoyer la confirmation de ton contrat, tes reçus et les informations légales liées à ton abonnement (avis avant reconduction, changement de tarif).",
  'v2.confidentialite.facturation.p2': "Pour gérer l’abonnement et les paiements, cette adresse est transmise à notre prestataire de paiement, Mollie. Elle est conservée pendant la durée légale de conservation des documents comptables et n’est jamais utilisée à des fins commerciales ni de prospection.",
  'v2.confidentialite.droits.heading': "Tes droits",
  'v2.confidentialite.droits.pre': "Accès, rectification, suppression, opposition, portabilité, limitation — c’est toi qui décides. Le responsable de traitement est ",
  'v2.confidentialite.droits.mid': " (voir les mentions légales). Pour exercer tes droits, écris à ",
  'v2.confidentialite.droits.post': " ; tu peux aussi introduire une réclamation auprès de la CNIL. Si tu as un compte, tu peux effacer définitivement tes données serveur ci-dessous.",
  'v2.confidentialite.signalements.heading': "Signalements de définitions",
  'v2.confidentialite.signalements.p1': "Quand tu signales une définition, on enregistre le mot et la définition concernés, la raison choisie et, si tu en ajoutes une, ta note. Ces éléments ne servent qu’à améliorer la qualité des grilles (intérêt légitime). Si tu es connecté·e, le signalement est rattaché à ton compte pour éviter les doublons.",
  'v2.confidentialite.signalements.p2': "Les signalements sont conservés jusqu’à leur traitement, puis la note est purgée. Si tu supprimes ton compte, tes signalements sont anonymisés : le signal de qualité reste, mais plus rien ne te relie à eux.",
  'signalement.trigger': "Signaler",
  'signalement.trigger.aria': "Signaler cette définition",
  'signalement.title': "Signaler cette définition",
  'signalement.reason.legend': "Pourquoi signales-tu cette définition ?",
  'signalement.reason.mot_offensant': "Le mot est choquant ou déplacé",
  'signalement.reason.definition_offensante': "La définition est choquante",
  'signalement.reason.erreur_sens': "La définition ne colle pas au mot",
  'signalement.reason.erreur_grammaire': "Bon sens, mais faute d’accord, de genre ou de conjugaison",
  'signalement.reason.definition_revele': "La définition contient ou trahit la réponse",
  'signalement.reason.ambigu': "Plusieurs réponses possibles",
  'signalement.reason.trop_facile': "Trop facile",
  'signalement.reason.trop_difficile': "Trop difficile",
  'signalement.reason.autre': "Autre (précise si tu veux)",
  'signalement.note.label': "Note (facultatif)",
  'signalement.note.placeholder': "Ajoute un détail si tu veux…",
  'signalement.notice.pre': "Ton signalement nous aide à améliorer les grilles — ",
  'signalement.notice.link': "en savoir plus",
  'signalement.submit': "Envoyer",
  'signalement.cancel': "Annuler",
  'signalement.success': "Merci, c’est signalé",
  'signalement.error': "Signalement impossible pour le moment. Réessaie plus tard.",
  'signalement.error.rateLimited': "Tu as signalé trop de fois récemment. Réessaie dans un moment.",
  'route.signalements.heading': "Signalements",
  'route.signalements.intro': "Les définitions signalées par les joueurs, regroupées par mot et par raison. Les contenus sensibles sont en tête.",
  'route.signalements.empty': "Aucun signalement en attente. Tout est propre !",
  'route.signalements.error': "Impossible de charger les signalements. Réessaie.",
  'route.signalements.count_one': "{{count}} signalement",
  'route.signalements.count_other': "{{count}} signalements",
  'route.signalements.latestNote': "Dernière note : {{note}}",
  'route.signalements.harmBadge': "Sensible",
  'route.signalements.mineBadge': "dont toi",
  'route.signalements.mineBadge.only': "toi",
  'route.signalements.tabsAria': "Choisir la vue des signalements",
  'route.signalements.onglet.aTraiter': "À traiter",
  'route.signalements.onglet.historique': "Historique",
  'route.signalements.history.empty': "Aucun signalement traité pour le moment.",
  'route.signalements.history.decision.action': "Traité",
  'route.signalements.history.decision.dismiss': "Rejeté",
  'route.signalements.reopen': "Réouvrir",
  'route.signalements.reopen.aria': "Réouvrir le signalement sur {{mot}} et annuler la correction",
  'route.signalements.reopen.aria.dismiss': "Réouvrir le signalement sur {{mot}}",
  'route.signalements.reopen.toast': "Signalement réouvert ; correction annulée.",
  'route.signalements.reopen.error': "Réouverture impossible pour le moment. Réessaie.",
  'route.signalements.reopen.retryError': "La correction est annulée, mais le signalement n’a pas pu repasser en file. Réessaie.",
  'route.signalements.reopen.confirm.title': "Réouvrir ce signalement ?",
  'route.signalements.reopen.confirm.body': "L’annulation ne restaure pas forcément les grilles déjà générées : selon la correction d’origine, seule la génération future est concernée.",
  'route.signalements.reopen.confirm.bodyDismiss': "Le signalement repasse dans la file À traiter. Aucune correction n’a été appliquée, donc rien n’est annulé.",
  'route.signalements.reopen.confirm.cancel': "Annuler",
  'route.signalements.reopen.confirm.confirm': "Réouvrir",
  'route.signalements.surface.solo': "Solo",
  'route.signalements.surface.daily': "Grille du jour",
  'route.signalements.surface.multiplayer': "Multijoueur",
  'route.signalements.surface.mini_game': "Mini-jeu",
  'route.signalements.puzzleContext': "réf. {{id}}",
  'route.signalements.reject': "Rejeter",
  'route.signalements.reject.aria': "Rejeter les signalements sur {{mot}}",
  'route.signalements.markHandled': "Marquer comme traité",
  'route.signalements.markHandled.aria': "Marquer comme traité les signalements sur {{mot}}",
  'route.signalements.toast.dismissed': "Signalement rejeté",
  'route.signalements.toast.handled': "Signalement marqué comme traité",
  'route.signalements.toast.error': "Action impossible pour le moment. Réessaie.",
  'correction.trigger': "Corriger",
  'correction.title': "Corriger la définition",
  'correction.mode.legend': "Que veux-tu faire ?",
  'correction.mode.replace': "Remplacer la définition",
  'correction.mode.forbid': "Interdire cette définition",
  'correction.forbid.needWord': "mot requis pour interdire",
  'correction.newClue.label': "Nouvelle définition",
  'correction.newClue.placeholder': "Saisis la définition corrigée…",
  'correction.replace.styleLegend': "Comment veux-tu remplacer ?",
  'correction.replace.write': "Écrire une nouvelle définition",
  'correction.replace.pick': "Choisir parmi les autres définitions",
  'correction.pick.legend': "Autres définitions",
  'correction.pick.empty': "Pas d’autre définition pour ce mot. Écris plutôt la nouvelle définition.",
  'correction.pick.error': "Impossible de charger les autres définitions. Écris plutôt la nouvelle définition.",
  'correction.submit': "Enregistrer la correction",
  'correction.cancel': "Annuler",
  'correction.close': "Fermer",
  'correction.retry': "Réessayer",
  'correction.retryNotice': "La correction est enregistrée, mais le signalement n’a pas pu être marqué comme traité. Réessaie.",
  'correction.rejected.lastClue': "Cette définition est la seule du mot — corrige le texte ou blackliste le mot.",
  'correction.error': "Correction impossible pour le moment. Réessaie.",
  'correction.success': "Correction enregistrée",
  'correction.progress.pending': "Correction en cours…",
  'correction.progress.running': "Correction en cours — {{patched}}/{{matched}} grilles",
  'correction.progress.done': "Terminé — {{patched}} grilles corrigées",
  'correction.progress.failed': "La correction des grilles a échoué. Réessaie plus tard.",
  'blocklist.trigger': "Blacklister le mot",
  'blocklist.trigger.needWord': "mot requis",
  'blocklist.title': "Blacklister le mot",
  'blocklist.warning': "Le mot est retiré des futures grilles et effacé de toutes les grilles existantes. C’est irréversible.",
  'blocklist.preview.loading': "Calcul de l’impact…",
  'blocklist.preview.error': "Impossible de calculer l’impact. Réessaie.",
  'blocklist.preview.counts': "{{dailies}} grille(s) du jour et {{solo}} grille(s) libre(s) seront régénérées ou supprimées.",
  'correction.preview.loading': "Calcul de l’impact…",
  'correction.preview.error': "Impossible de calculer l’impact.",
  'correction.preview.counts': "{{dailies}} grille(s) du jour et {{solo}} grille(s) libre(s) concernée(s).",
  'correction.preview.none': "Aucune grille déjà générée n’utilise cette définition.",
  'blocklist.confirm.label': "Tape « {{word}} » pour confirmer",
  'blocklist.confirm.placeholder': "Retape le mot",
  'blocklist.submit': "Confirmer le blacklistage",
  'blocklist.cancel': "Annuler",
  'blocklist.close': "Fermer",
  'blocklist.retry': "Réessayer",
  'blocklist.retryNotice': "Le mot est blacklisté, mais le signalement n’a pas pu être marqué comme traité. Réessaie.",
  'blocklist.error': "Blacklistage impossible pour le moment. Réessaie.",
  'blocklist.success': "Mot blacklisté",
  'blocklist.progress.pending': "Régénération en cours…",
  'blocklist.progress.running': "Régénération en cours — {{patched}}/{{matched}} grilles",
  'blocklist.progress.done': "Terminé — {{patched}} grilles traitées",
  'blocklist.progress.failed': "La régénération des grilles a échoué. Réessaie plus tard.",
  'v2.mentions.title': "Mentions légales",
  'v2.mentions.lede': "L’essentiel sur l’éditeur du jeu, l’hébergement et tes droits.",
  'v2.mentions.editeur.heading': "Éditeur",
  'v2.mentions.editeur.p1.pre': "WordSparrow est édité par ",
  'v2.mentions.editeur.p1.mid': ", EURL au capital de 1 000 €, dont le siège social est situé 32 rue Avaulée, 92240 Malakoff (France). Immatriculée au ",
  'v2.mentions.editeur.p1.post': " sous le n° 851 880 401 — SIRET 851 880 401 00019 — TVA intracommunautaire FR63 851880401.",
  'v2.mentions.editeur.p2.pre': "Directeur de la publication : ",
  'v2.mentions.editeur.p2.mid': ". Contact : ",
  'v2.mentions.hebergement.heading': "Hébergement",
  'v2.mentions.hebergement.pre': "Le service est hébergé par ",
  'v2.mentions.hebergement.mid1': ", Industriestr. 25, 91710 Gunzenhausen, Allemagne (",
  'v2.mentions.hebergement.mid2': "). La diffusion du contenu statique et la résolution DNS sont assurées par ",
  'v2.mentions.hebergement.mid3': ", 101 Townsend St, San Francisco, CA 94107, États-Unis (",
  'v2.mentions.pi.heading': "Propriété intellectuelle",
  'v2.mentions.pi.p1': "Le code source de WordSparrow est publié sous licence FSL-1.1-MIT (Functional Source License 1.1, MIT dans le futur). Voir le dépôt public du projet pour les conditions d’utilisation, de modification et de redistribution.",
  'v2.mentions.pi.p2.link1': "Licences des logiciels tiers",
  'v2.mentions.pi.p2.mid': " embarqués dans l’application — et nos ",
  'v2.mentions.pi.p2.link2': "remerciements",
  'v2.mentions.pi.p2.post': " à celles et ceux qui les font vivre.",
  'v2.mentions.donnees.heading': "Données personnelles",
  'v2.mentions.donnees.pre': "Le traitement de tes données personnelles est décrit dans la ",
  'v2.mentions.donnees.link': "politique de confidentialité",
  'v2.mentions.mediation.heading': "Médiation de la consommation",
  'v2.mentions.mediation.pre': "Conformément aux articles L611-1 et suivants du Code de la consommation, tu peux recourir gratuitement à un médiateur de la consommation pour la résolution amiable d’un litige, après avoir tenté de le régler directement avec nous. Le médiateur compétent est ",
  'v2.mentions.mediation.post': " (Association des Médiateurs Européens), 197 boulevard Saint-Germain, 75007 Paris (",
  'v2.mentions.signaler.heading': "Signaler un problème",
  'v2.mentions.signaler.pre': "Pour signaler un contenu illicite, un bug ou une faille de sécurité, écris à ",
  'v2.nav.aria': 'Navigation principale',
  'v2.nav.accueil': 'Accueil',
  'v2.nav.grilles': 'Grilles',
  'v2.nav.brandAria': 'Accueil',
  'v2.nav.menuOpen': 'Ouvrir le menu',
  'v2.menu.guest': 'Invité',
  'v2.menu.subline.streak': '🔥 série {{streak}}',
  'v2.menu.subline.connected': 'Connecté',
  'v2.menu.subline.noAccount': 'Sans compte',
  'v2.menu.dialogTitle': 'Menu',
  'v2.menu.navAria': 'Menu',
  'v2.menu.reglages': 'Réglages',
  'v2.menu.signalements': 'Signalements',
  'v2.calendar.action.revoir': 'Revoir',
  'v2.calendar.action.reprendre': 'Reprendre',
  'v2.calendar.action.commencer': 'Commencer',
  'v2.calendar.prevMonth': 'Mois précédent',
  'v2.calendar.nextMonth': 'Mois suivant',
  'v2.calendar.day.aria': '{{action}} — {{date}}',
  'v2.calendar.day.ariaProgress': '{{action}} — {{date}} — {{pct}} %',
  'v2.calendar.day.ariaPaywalled': "Grille réservée à l’abonnement — {{date}}",
  'v2.calendar.legend.done': ' terminée ·',
  'v2.calendar.legend.progress': ' en cours ·',
  'v2.calendar.legend.new': ' à jouer',
  'v2.calendar.legend.paywalled': " réservées à l’abonnement",
  'v2.grilles.title': 'Grilles',
  'v2.grilles.onglet.quotidiennes': 'Quotidiennes',
  'v2.grilles.onglet.aFinir': 'À finir',
  'v2.grilles.onglet.plusieurs': 'À plusieurs',
  'v2.grilles.tabsAria': 'Choisir la vue des grilles',
  'v2.grilles.loading': 'Chargement des grilles',
  'v2.grilles.aFinir.reprendreAria': 'Reprendre — {{date}}',
  'v2.grilles.aFinir.rowTitle': '{{date}} · n°{{num}}',
  'v2.grilles.aFinir.rowMeta': 'En cours · {{filled}} / {{total}} cases',
  'v2.grilles.plusieurs.join': 'Rejoindre avec un code',
  'v2.grilles.plusieurs.loading': 'Chargement des parties',
  'v2.grilles.emptyScene.aria': "Un moineau au-dessus d’un nid",
  'v2.grilles.empty.new.title': 'Tu as tout joué !',
  'v2.grilles.empty.new.body': 'Aucune grille à commencer pour l’instant — reviens demain pour la prochaine.',
  'v2.grilles.empty.progress.title': 'Aucune grille en cours',
  'v2.grilles.empty.progress.body': 'Tu n’as pas de grille commencée à reprendre pour le moment.',
  'v2.grilles.empty.cta': 'Jouer la grille du jour',
  'v2.grilles.lobbiesEmpty.title': 'Aucune partie à plusieurs',
  'v2.grilles.lobbiesEmpty.body': 'Crée une partie et invite tes proches — vous remplissez la même grille ensemble. Sans compte, les parties terminées sont conservées 7 jours.',
  'v2.grilles.lobbiesEmpty.cta': 'Créer une partie',
  'v2.loader.announce.exhausted': 'Connexion au serveur impossible. Utilise le bouton Réessayer.',
  'v2.loader.announce.retrying': 'Reconnexion en cours',
  'v2.loader.error.title': 'Connexion impossible',
  'v2.loader.error.body': 'Le serveur ne répond pas. Vérifie ta connexion, puis réessaie.',
  'v2.loader.reconnecting': 'Reconnexion…',
  'v2.sparrow.flight.aria': "Un moineau qui s’envole",
  'v2.sparrow.celebration.aria': 'Un moineau qui chante sur une branche fleurie',
  'seo.route.home.title': 'WordSparrow — mots fléchés français en ligne',
  'seo.route.home.description':
    'Joue aux mots fléchés en français, en solo ou en multijoueur. Gratuit, sans inscription.',
  'seo.route.play.title': 'Grille du jour — WordSparrow',
  'seo.route.play.description': 'Résous la grille de mots fléchés du jour, en français.',
  'seo.route.grilles.title': 'Anciennes grilles — WordSparrow',
  'seo.route.grilles.description': 'Toutes les grilles passées de WordSparrow, avec ta progression.',
  'seo.route.aide.title': 'Aide — WordSparrow',
  'seo.route.aide.description': 'Comment jouer aux mots fléchés sur WordSparrow : règles, astuces, raccourcis.',
  'seo.route.mentionsLegales.title': 'Mentions légales — WordSparrow',
  'seo.route.mentionsLegales.description': 'Mentions légales et informations éditoriales de WordSparrow.',
  'seo.route.confidentialite.title': 'Confidentialité — WordSparrow',
  'seo.route.confidentialite.description': 'Politique de confidentialité de WordSparrow.',
  'seo.route.conditionsAbonnement.title': 'Conditions générales de vente — WordSparrow',
  'seo.route.conditionsAbonnement.description': "Conditions générales de vente de l’abonnement WordSparrow.",
  'seo.route.aPropos.title': 'À propos — WordSparrow',
  'seo.route.aPropos.description':
    'WordSparrow, un jeu de mots fléchés édité par ISHO IT — et un grand merci aux logiciels libres, polices et dictionnaires qui le font vivre.',
  'seo.noindex.compte.title': 'Mon compte — WordSparrow',
  'seo.noindex.compte.description': 'Gère ton compte WordSparrow.',
  'seo.noindex.signalements.title': 'Signalements — WordSparrow',
  'seo.noindex.signalements.description': 'File de triage des signalements de définitions (réservée aux mainteneurs).',
  'seo.noindex.contribuer.title': 'Campagne — WordSparrow',
  'seo.noindex.contribuer.description':
    'Aide à améliorer les indices de mots fléchés en notant les définitions générées.',
  'seo.noindex.contribuerPairs.title': 'Campagne par paires — WordSparrow',
  'seo.noindex.contribuerPairs.description': 'Aide à départager deux définitions générées pour le même mot.',
  'seo.noindex.reglages.title': 'Réglages — WordSparrow',
  'seo.noindex.reglages.description': 'Réglages et préférences de ton compte WordSparrow.',
  'seo.noindex.grillesAFinir.title': 'Grilles à finir — WordSparrow',
  'seo.noindex.grillesAFinir.description': 'Reprends tes grilles de mots fléchés commencées.',
  'seo.noindex.grillesMultijoueur.title': 'Parties à plusieurs — WordSparrow',
  'seo.noindex.grillesMultijoueur.description': 'Tes parties de mots fléchés à plusieurs.',
  'seo.noindex.finish.title': 'Partie terminée — WordSparrow',
  'seo.noindex.finish.description': 'Tu as terminé la grille. Bravo !',
  'seo.noindex.abonnement.title': 'Abonnement — WordSparrow',
  'seo.noindex.abonnement.description': 'Gère ton abonnement WordSparrow.',
  'seo.noindex.abonnementSucces.title': 'Merci — WordSparrow',
  'seo.noindex.abonnementSucces.description': 'Confirmation de ton abonnement WordSparrow.',
  'seo.noindex.abonnementAnnule.title': 'Paiement annulé — WordSparrow',
  'seo.noindex.abonnementAnnule.description': 'Ton paiement a été annulé, aucun débit.',
  'seo.noindex.connexion.title': 'Connexion — WordSparrow',
  'seo.shell.lobby.title': 'Partie — WordSparrow',
  'seo.shell.lobby.description': 'Partie de mots fléchés en multijoueur.',
  'seo.shell.join.title': 'Rejoindre une partie — WordSparrow',
  'seo.shell.join.description': 'Rejoins une partie de mots fléchés.',
  'seo.breadcrumb.accueil': 'Accueil',
  'seo.play.game.name': 'WordSparrow — mots fléchés du jour',
  'seo.play.game.description':
    'Grille de mots fléchés française quotidienne, jouable en ligne sans inscription.',
  'route.rootError.title': 'Une erreur est survenue',
  'route.rootError.body': 'Recharge la page pour réessayer.',
  'route.rootError.cta': 'Recharger la page',
  'route.play.unavailable.sceneAria': 'Un lever de soleil',
  'route.play.unavailable.title': 'Bientôt disponible',
  'route.play.unavailable.body': 'La grille du jour se prépare. Elle arrive au lever du soleil.',
  'route.play.unavailable.cta': 'Voir les grilles passées',
  'route.play.loadError.title': 'Connexion interrompue',
  'route.play.loadError.body': "La grille n’a pas pu être chargée. Vérifie ta connexion et réessaie.",
  'route.play.pending.aria': 'Chargement de la grille',
  'route.play.pending.text': 'Chargement de la grille…',
  'route.join.connecting': 'Connexion à la partie…',
  'route.join.searching': 'Recherche de la partie…',
  'route.join.notFound.title': 'Partie introuvable',
  'route.join.notFound.body': 'Code invalide ou partie expirée.',
  'route.join.notFound.cta': 'Accueil',
  'route.lobby.introuvable.title': 'Partie introuvable',
  'route.lobby.introuvable.body': "Cette partie n’existe plus ou le lien a expiré.",
  'route.lobby.introuvable.cta': 'Accueil',
  'route.lobby.evicted.title': 'La partie a continué sans toi',
  'route.lobby.evicted.body':
    'Ta connexion est restée coupée trop longtemps et ta place a été libérée. Demande un nouveau code pour revenir.',
  'route.lobby.evicted.cta': 'Accueil',
  'route.lobby.placeholder.connecting': 'Connexion à la partie…',
  'route.lobby.placeholder.loading': 'Chargement de la partie…',
  'route.lobby.placeholder.inProgress': 'La partie est en cours…',
  'route.lobby.error.cannotCreate': 'Impossible de créer une partie. Réessaie.',
  'route.lobby.error.cannotClaim': 'Impossible de reprendre la partie.',
  'route.contribuer.heading': 'Campagne de qualité des indices',
  'route.contribuer.skeleton.intro':
    'Note la qualité des définitions en un clic : mauvaise, à passer, ou bonne. Tes retours alimentent la sélection des indices.',
  'route.contribuer.intro':
    'Lis chaque définition et juge si elle décrit bien le mot : note-la bonne ou mauvaise, corrige-la, ou passe si tu ne peux pas trancher.',
  'route.contribuer.modePaires': 'Mode paires →',
  'route.contribuer.stats.aria': 'Statistiques de la session',
  'route.contribuer.stats.rated': 'Notées',
  'route.contribuer.stats.enriched': 'Enrichies',
  'route.contribuer.stats.streak': 'Série',
  'route.contribuer.empty': "Plus d’indices à noter pour l’instant. Merci !",
  'route.contribuer.legend.aria': 'Raccourcis clavier',
  'route.contribuer.legend.rate': 'noter',
  'route.contribuer.legend.correct': 'corriger',
  'route.contribuer.legend.confirm': 'confirmer / enregistrer',
  'route.contribuer.kbd.espace': 'Espace',
  'route.contribuer.toast.correctionProposed': 'Correction proposée — merci !',
  'route.contribuer.toast.signaled': 'Indice signalé. Merci de nous aider à corriger le tir.',
  'route.contribuer.toast.undone': 'Action annulée.',
  'route.contribuer.error.unavailable': 'Le sondage n’est pas disponible pour le moment.',
  'route.contribuer.error.correctionAuth': 'Connecte-toi pour proposer une correction.',
  'route.contribuer.error.correctifRejected': 'Correction rejetée par le filtre {{filterId}} : {{reason}}.',
  'route.contribuer.error.reasonUnknown': 'motif inconnu',
  'route.contribuer.error.undoExpired': 'Trop tard pour annuler : la campagne est terminée.',
  'route.contribuer.error.undoUnavailable': 'Cette action ne peut plus être annulée.',
  'route.contribuerPairs.skeletonHeading': 'Campagne par paires',
  'route.contribuerPairs.skeleton.intro':
    'Compare deux définitions du même mot. Une préférence, ou aucune si les deux se valent.',
  'route.contribuerPairs.intro':
    'Compare deux définitions du même mot. Choisis ta préférée, marque-les comme toutes deux bonnes ou mauvaises, ou passe si tu ne peux pas trancher.',
  'route.contribuerPairs.modeBinaire': 'Mode binaire →',
  'route.contribuerPairs.empty': "Plus de paires à comparer pour l’instant. Merci !",
  'route.contribuerPairs.legend.prefer': 'préférer',
  'route.contribuerPairs.legend.bothBad': 'les deux mauvaises',
  'route.contribuerPairs.legend.skip': 'passer',
  'route.contribuerPairs.legend.bothGood': 'les deux bonnes',
} as const;
